import { isMobile } from '../../../helpers';

export function isSmallSearchDevice(deviceType: string): boolean {
  return isMobile(deviceType) || window.innerHeight <= 600;
}
